<template>
  <div class="reviewsForMemberCard">
    <div>
      <div>
        <div class="header">
          <b-button class="backButton" @click="deselectUser"><i class="bi bi-caret-left-fill"></i></b-button>
          <h3 class="main-color">{{ memberName }}</h3>
        </div>
        <span class="main-color">
          <span class="tab"></span>1 - {{ $t(localeConsts.bad) }} <span class="tab"></span> 2 - {{ $t(localeConsts.improvable)
          }}<span class="tab"></span> 3 - {{ $t(localeConsts.okay) }}<span class="tab"></span> 4 - {{ $t(localeConsts.great)
          }}<span class="tab"></span> 5 -
          {{ $t(localeConsts.excellent) }}
        </span>
      </div>
      <b-table :fields="columns" :items="peerReviewsMapped" striped></b-table>
      <h5 class="main-color font-bold">Strengths & Improvements</h5>
      <b-table :fields="commentColumns" :items="peerReviewsMappedWithoutAverage" striped></b-table>
      <h5 class="main-color font-bold">Comments</h5>
      <h6 style="color: red">You are viewing all peer review comments, please include student's name in content.</h6>
      <ProfessorPeerReviewsComments :editable="true" :user-id="userId" />
    </div>
  </div>
</template>

<script>
import mapGettersMixin from '../../../mixins/mapGettersMixin'
import axios from '../../../../axios'
import { processPromisesMixin } from '../../../mixins/processPromisesMixin'
import ProfessorPeerReviewsComments from './ProfessorPeerReviewsComments.vue'

export default {
  components: { ProfessorPeerReviewsComments },
  mixins: [processPromisesMixin, mapGettersMixin],
  props: {
    userId: Number,
    selectedRound: Number,
    memberName: String
  },
  data() {
    return {
      localeConsts: {
        overallValue: 'PEERREVIEW.OVERALLVALUE',
        engagement: 'PEERREVIEW.ENGAGEMENT',
        teamWork: 'PEERREVIEW.TEAMWORK',
        communication: 'PEERREVIEW.COMMUNICATION',
        technicalSkills: 'PEERREVIEW.TECHNICALSKILLS',
        expertise: 'PEERREVIEW.EXPERTISE',
        save: 'PEERREVIEW.SAVE',
        strengths: 'PEERREVIEW.STRENGTHS',
        improvements: 'PEERREVIEW.IMPROVEMENTS',
        bad: 'PEERREVIEW.BAD',
        improvable: 'PEERREVIEW.IMPROVABLE',
        okay: 'PEERREVIEW.OKAY',
        great: 'PEERREVIEW.GREAT',
        excellent: 'PEERREVIEW.EXCELLENT'
      },
      peerReviewRounds: [],
      peerReviews: [],
      peerReviewsMapped: [],
      strengthsAndImprovements: {
        strengths: [],
        improvements: []
      },
      counterToPseudonym: {}
    }
  },
  computed: {
    columns() {
      return [
        {
          label: '',
          key: 'member',
          thClass: 'peerReviewTableHeader',
          tdClass: 'peerReviewNumberCell'
        },
        {
          label: this.$i18n.t(this.localeConsts.overallValue),
          key: 'global_mark',
          thClass: 'peerReviewTableHeader',
          tdClass: 'peerReviewNumberCell'
        },
        {
          label: this.$i18n.t(this.localeConsts.engagement),
          key: 'engagement_level',
          thClass: 'peerReviewTableHeader',
          tdClass: 'peerReviewNumberCell'
        },
        {
          label: this.$i18n.t(this.localeConsts.expertise),
          key: 'practical_skills_level',
          thClass: 'peerReviewTableHeader',
          tdClass: 'peerReviewNumberCell'
        },
        {
          label: this.$i18n.t(this.localeConsts.teamWork),
          key: 'team_work_ability_level',
          thClass: 'peerReviewTableHeader',
          tdClass: 'peerReviewNumberCell'
        },
        {
          label: this.$i18n.t(this.localeConsts.communication),
          key: 'communication_skills_level',
          thClass: 'peerReviewTableHeader',
          tdClass: 'peerReviewNumberCell'
        },
        {
          label: this.$i18n.t(this.localeConsts.technicalSkills),
          key: 'technical_skills_level',
          thClass: 'peerReviewTableHeader',
          tdClass: 'peerReviewNumberCell'
        }
      ]
    },
    commentColumns() {
      return [
        {
          label: '',
          key: 'member',
          thClass: 'peerReviewTableHeader',
          tdClass: 'peerReviewMembersCell'
        },
        {
          label: this.$i18n.t(this.localeConsts.strengths),
          key: 'skills_comments',
          thClass: 'peerReviewTableHeader comment-headers',
          tdClass: ' peerReviewTextCell'
        },
        {
          label: this.$i18n.t(this.localeConsts.improvements),
          key: 'improvements_comments',
          thClass: 'peerReviewTableHeader comment-headers',
          tdClass: 'peerReviewTextCell'
        }
      ]
    },
    peerReviewsMappedWithoutAverage() {
      return this.peerReviewsMapped.filter((review) => review.member !== 'Average')
    }
  },
  created() {
    this.fetchPeerReviewRounds()
    this.fetchPeerReviews()
  },
  methods: {
    async fetchPeerReviewRounds() {
      /* In order  to get only the relevant rounds of a project it is necessary to supply the term and module id. We are getting those arguments via the project */
      const responseProjectId = await this.getProjectId
      const response = await axios.get(`projects/${responseProjectId}`)
      const termId = response.data.term.termId
      const moduleId = response.data.module.id
      const params = {
        params: {
          term_id: termId,
          module_id: moduleId
        }
      }
      const responseReviewRounds = await axios.get('peer-review-rounds/', params)
      const reviewRounds = responseReviewRounds.data
      this.peerReviewRounds = reviewRounds
    },
    async fetchPeerReviews() {
      const response = await this.getRequestWithProjectIdPromise('peer-reviews/')
      const fetchedPeerReviews = response.data
      this.peerReviews = fetchedPeerReviews
      this.mapPeerReviews()
      this.determineNumberOfTeamMembers()
    },

    mapPeerReviews() {
      this.peerReviewsMapped = this.peerReviews
        .filter((round) => round.peer_review_round === this.selectedRound && round.targeted_student === this.userId)
        .map((item) => ({
          ...item,
          member: item.is_self ? 'Self' : `Team Member`
        }))
        .sort((a, b) => {
          if (a.is_self && !b.is_self) return -1
          if (!a.is_self && b.is_self) return 1
          return 0
        })
      this.addAverageRow()
    },
    addAverageRow() {
      const averages = this.calculateAverages()

      this.peerReviewsMapped.push({
        ...averages,
        member: 'Average'
      })
    },
    calculateAverages() {
      const averages = {}
      let count = 0

      for (const review of this.peerReviewsMapped) {
        if (review.is_self) {
          continue
        }

        for (const key in review) {
          if (key !== 'member' && key !== 'is_self' && typeof review[key] === 'number') {
            if (!averages[key]) {
              averages[key] = 0
            }
            averages[key] += review[key]
          }
        }

        count++
      }

      for (const key in averages) {
        averages[key] = parseFloat((averages[key] / count).toFixed(2))
      }

      return averages
    },
    determineNumberOfTeamMembers() {
      let counter = 0
      const counterToPseudonym = {}
      const firstReviewEntry = this.peerReviews[0]
      for (const key in firstReviewEntry) {
        if (key !== 'x-label') {
          counter++
          counterToPseudonym[counter] = key
        }
      }

      this.counterToPseudonym = counterToPseudonym
    },
    selectRoundAndPrint(value) {
      this.mapPeerReviews()
    },
    returnMembersWhoReviewedAndMemberCount() {
      return this.peerReviewsMapped.length, Object.keys(this.counterToPseudonym).length //eslint-disable-line
    },
    deselectUser() {
      this.$emit('deselectedUser')
    }
  }
}
</script>

<style>
.reviewsForMemberCard {
  border-radius: 12px;
  height: 100vh;
  width: 70vw;
}

.backButton {
  margin-right: 10px;
  margin-bottom: 15px;
}

.header {
  display: flex;
  align-items: center;
}

.roundDropDown {
  width: fit-content;
}

.peerReviewTableHeader {
  padding: 0;
}

/* Table */
.peerReviewTableHeader {
  color: #451a6e !important;
  background-color: #c1afd1 !important;
  line-break: auto;
  white-space: pre-wrap;
  width: max-content;
  text-align: center;
  padding: 10px !important;
}

.peerReviewNumberCell {
  vertical-align: middle;
  height: 60px;
  max-width: 200px;
  text-align: center;
  padding: 5px !important;
}

.peerReviewTextCell {
  line-break: anywhere;
  width: auto;
}

.peerReviewMembersCell {
  max-width: 200px;
  text-align: center;
  vertical-align: middle;
}

.tab {
  display: inline-block;
  margin-left: 40px;
}
</style>
